'use strict';
module.exports = Object.create(null);
